if (!customElements.get('terence-film-gallery')) {
  customElements.define('terence-film-gallery', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.video = this.querySelector('video');
      this.buttons = [...this.querySelectorAll('[data-film-src]')];
      this.index = 0;
      this.video.muted = true;
      this.buttons.forEach((button, index) => button.addEventListener('click', () => this.select(index), options));
      this.querySelector('.tb-film-prev').addEventListener('click', () => this.select(this.index - 1), options);
      this.querySelector('.tb-film-next').addEventListener('click', () => this.select(this.index + 1), options);
      this.video.addEventListener('ended', () => this.select(this.index + 1), options);
      this.querySelector('.tb-film-rail').addEventListener('keydown', event => {
        if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
        event.preventDefault();
        this.select(event.key === 'Home' ? 0 : event.key === 'End' ? this.buttons.length - 1 : this.index + (event.key === 'ArrowRight' ? 1 : -1));
        this.buttons[this.index].focus();
      }, options);
      this.video.addEventListener('touchstart', event => {
        const point = event.changedTouches[0];
        const rect = this.video.getBoundingClientRect();
        this.touch = point.clientY < rect.bottom - 60 ? { x: point.clientX, y: point.clientY } : null;
      }, { ...options, passive: true });
      this.video.addEventListener('touchend', event => {
        if (!this.touch) return;
        const point = event.changedTouches[0];
        const dx = point.clientX - this.touch.x;
        const dy = point.clientY - this.touch.y;
        this.touch = null;
        if (Math.abs(dx) > 60 && Math.abs(dx) > Math.abs(dy) * 1.5) this.select(this.index + (dx < 0 ? 1 : -1));
      }, { ...options, passive: true });
      this.video.play().catch(() => {});
    }
    select(index) {
      const next = (index + this.buttons.length) % this.buttons.length;
      if (next === this.index) { this.video.play().catch(() => {}); return; }
      this.index = next;
      const button = this.buttons[next];
      this.video.pause();
      this.video.src = button.dataset.filmSrc;
      if (button.dataset.filmPoster) this.video.poster = button.dataset.filmPoster;
      else this.video.removeAttribute('poster');
      this.video.setAttribute('aria-label', button.dataset.filmLabel);
      this.buttons.forEach((item, i) => item.setAttribute('aria-pressed', String(i === next)));
      this.querySelector('.tb-film-count').textContent = `${String(next + 1).padStart(2, '0')} / ${String(this.buttons.length).padStart(2, '0')}`;
      this.video.load();
      this.video.play().catch(() => {});
    }
    disconnectedCallback() {
      this.video?.pause();
      this.controller?.abort();
      this.controller = null;
    }
  });
}
